import BaseComponentController from '.././base-component.controller';

class TextInputController extends BaseComponentController {
    constructor(_, componentRegistryService, $q,dateTimeService) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors:[],
            isValid: false
        };
        this.formatDate = dateTimeService.formatDate;
        this.parseDateToString = dateTimeService.parseDateToString;
    }

    init() {
        this.vm = {
            errors:[],
            isValid: !this.required || !this._.isEmpty(this.model)
        };

        if (this.model && this.isDateField) {
            this.model = this.parseDateToString(this.model);
        }
    }

    validState() {
        return this.vm.isValid;
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this.required === true) {
            if (this._.isEmpty(this.model)) {
                this.vm.isValid = false;
                this.vm.errors = [`"${this.fieldName}" is a required field`];
            } else {
                    this.vm.errors = [];
                    this.vm.isValid = true;
            }
        }

        let result = this.onValidate({ errors: this.vm.errors, model: this.model });
        if (result !== undefined) {
            if (result === true) {
                this.vm.isValid = true;
            } else {
                this.vm.isValid = false;
            }
        }
      
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }
}

TextInputController.$inject = ['_', 'componentRegistryService','$q', 'dateTimeService'];

let textinputComponent = {
    controller: TextInputController,
    bindings: {
        modelName:'@',
        fieldName:'@',
        readonly:'<',
        required:'<',
        onValidate:'&',
        isCurrency:'<',
        placeHolder:'@',
        isDateField:'<',
        infoTextField:'@'
    },
    templateUrl:`app/components/text-input/text-input.html`
};

export default textinputComponent;


// WEBPACK FOOTER //
// ./app/components/text-input/text-input.component.js